@if (dbSize === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Estimating size...
	</div>
}
@if (dbSize === null && errormessage) {
	<div class="loading-status">
		Unable to retrieve database size.<br />
		{{ errormessage }}
	</div>
}
@if (dbSize) {
	<div class="section-title">Estimated size in database</div>
	<p>
		{{asset.asset_name}} uses an estimated <strong>{{dbSize.estimated_mb / 1024 | number : "1.2-2"}} GB</strong>,
		or {{dbSize.percent_of_total | number : "1.2-2"}}% of the total database.
		This estimate only uses the three largest tables.
	</p>
	<div class="row">
		<div class="col-xl-6">
			<app-dvs-chart [options]="totalOptions" height="340px"></app-dvs-chart>
		</div>
		<div class="col-xl-6">
			<app-dvs-chart [options]="breakdownOptions" height="340px"></app-dvs-chart>
		</div>
	</div>
}
